function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PrivacySettingsTable from './PrivacySettingsTable';
import { Button } from '../Button/index';
import { Dialog } from '../Dialog/index';
import { getPrivacySettings, setPrivacySettings } from './privacySettings';
import { t } from '../i18n';
import { useState } from 'react';
export var privacySettingConfigs = [{
  settingsKey: 'c3',
  translationKey: 'advertising'
}, {
  settingsKey: 'c4',
  translationKey: 'socialMedia'
}, {
  settingsKey: 'c2',
  translationKey: 'webAnalytics'
}];
export var PrivacySettingsDialog = function PrivacySettingsDialog(props) {
  var _useState = useState(getPrivacySettings()),
      _useState2 = _slicedToArray(_useState, 2),
      localPrivacySettings = _useState2[0],
      setLocalPrivacySettings = _useState2[1];

  function setPrivacySetting(settingsKey, value) {
    setLocalPrivacySettings(_objectSpread(_objectSpread({}, localPrivacySettings), {}, _defineProperty({}, settingsKey, value)));
  }

  function savePrivacySettings() {
    setPrivacySettings(localPrivacySettings);
    props.onExit();
  }

  var domain = props.domain,
      privacyPolicyUrl = props.privacyPolicyUrl,
      thirdPartyPoliciesUrl = props.thirdPartyPoliciesUrl,
      dialogProps = _objectWithoutProperties(props, ["domain", "privacyPolicyUrl", "thirdPartyPoliciesUrl"]);

  var privacySettingsProperties = privacySettingConfigs.map(function (config) {
    return _objectSpread(_objectSpread({}, config), {}, {
      value: localPrivacySettings[config.settingsKey]
    });
  });
  var intro = t('privacy.introText', {
    domain: domain
  });
  intro += ' ' + t('privacy.privacyPolicy', {
    url: privacyPolicyUrl
  });

  if (thirdPartyPoliciesUrl) {
    intro += ' ' + t('privacy.thirdPartyPolicies', {
      url: thirdPartyPoliciesUrl
    });
  }

  intro += '.';
  return /*#__PURE__*/React.createElement(Dialog, _extends({}, dialogProps, {
    heading: t('privacy.dialogTitle', {
      domain: domain
    }),
    size: "full",
    actions: /*#__PURE__*/React.createElement(Button, {
      variation: "solid",
      onClick: savePrivacySettings
    }, t('privacy.save'))
  }), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: intro
    }
  }), /*#__PURE__*/React.createElement(PrivacySettingsTable, {
    domain: domain,
    privacySettings: privacySettingsProperties,
    setPrivacySetting: setPrivacySetting
  }));
};
export default PrivacySettingsDialog;